// When Staff PIN Login is enabled and someone is currently PIN-authenticated, the order
// should be tagged to them directly — the "Select a Server" step is redundant in that case.
export const getActiveServerId = () => {
  const enabled = localStorage.getItem('staff_login_enabled') === '1';
  const staffId = localStorage.getItem('active_staff_id');
  return enabled && staffId ? staffId : null;
};
